import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
//import makeStyles from '@mui/styles/makeStyles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CommentIcon from '@mui/icons-material/Comment';
import { maxHeight } from "@mui/system";
const useStyles = makeStyles((theme) => ({
  list: {
    margin: "0rem 0.5rem 0rem",
  },
}));

export default function CustomList(props) {
  const {
    checked,
    setChecked,
    items,
    marginTop,
    maxHeight
  } = props;

  const classes = useStyles();

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <div className={classes.list} style={{ marginTop: marginTop }}>
      <List sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: {maxHeight}, overflow: 'scroll', overflowX: 'hidden' }} dense>
        {items.map((value) => {
          const labelId = `checkbox-list-label-${value.id}`;

          return (
            <ListItem
              key={value.id}
              disablePadding
              dense
            >
              <ListItemButton role={undefined} onClick={handleToggle(value.id)} dense>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={checked.includes(value.id)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                    size={'small'}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={value.name} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}

CustomList.defaultProps = {
  maxHeight: 500
};

CustomList.propTypes = {
  inputTitle: PropTypes.any,
  maxHeight: PropTypes.any
};
